export class BlogNotFound {}
